(() => {
  // Stock map is populated from the JSON embedded in Liquid
  let STOCK_MAP = null;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function getFormId() {
    return $('[data-bundle-buy-buttons]')?.getAttribute('data-form-id')
      || $('[data-bundle-color-pickers]')?.getAttribute('data-form-id')
      || null;
  }

  // Size is now option2 (Pack Size is option1)
  function getSelectedSize(formId) {
    if (!formId) return null;

    const radio = $(`input[name="option2"][form="${formId}"]:checked`);
    if (radio?.value) return radio.value;

    const select = $(`select[name="option2"][form="${formId}"]`);
    if (select?.value) return select.value;

    const hidden = $(`input[name="option2"][type="hidden"][form="${formId}"]`);
    if (hidden?.value) return hidden.value;

    // Fallback: check inside variant-picker or globally
    const variantPicker = $(`variant-picker[form="${formId}"]`);
    if (variantPicker) {
      const radioInPicker = $(`input[name="option2"]:checked`, variantPicker);
      if (radioInPicker?.value) return radioInPicker.value;

      const hiddenInPicker = $(`input[name="option2"][type="hidden"]`, variantPicker);
      if (hiddenInPicker?.value) return hiddenInPicker.value;
    }

    // Global fallback
    const anyRadio = $(`input[name="option2"]:checked`);
    if (anyRadio?.value) return anyRadio.value;

    const anyHidden = $(`input[name="option2"][type="hidden"]`);
    if (anyHidden?.value) return anyHidden.value;

    return null;
  }

  /**
   * Load the stock map from the embedded JSON in Liquid.
   */
  function loadStockMap() {
    if (STOCK_MAP) return STOCK_MAP;

    const script = $('script[data-bundle-stock-map]');
    if (!script) {
      console.warn('[bundle-atc] No stock map found.');
      STOCK_MAP = {};
      return STOCK_MAP;
    }

    try {
      STOCK_MAP = JSON.parse(script.textContent);
    } catch (e) {
      console.error('[bundle-atc] Failed to parse stock map:', e);
      STOCK_MAP = {};
    }

    return STOCK_MAP;
  }

  /**
   * Get stock info for a handle + size from the embedded map.
   * Returns { available: boolean, variantId: number } or null if not found.
   */
  function getStockInfo(handle, size) {
    const map = loadStockMap();
    const product = map[handle];
    if (!product || !product.sizes) return null;

    // Try exact match first
    if (product.sizes[size]) {
      return product.sizes[size];
    }

    // Try case-insensitive match
    const sizeNorm = String(size).trim().toLowerCase();
    for (const [key, val] of Object.entries(product.sizes)) {
      if (String(key).trim().toLowerCase() === sizeNorm) {
        return val;
      }
    }

    return null;
  }

  function showError(msg) {
    const el = $('[data-bundle-atc-error]');
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
  }

  function clearError() {
    const el = $('[data-bundle-atc-error]');
    if (!el) return;
    el.textContent = '';
    el.style.display = 'none';
  }

  function getActiveSlots(root) {
    if (!root) return [];
    return $$('[data-bundle-slot]', root).filter(el => !el.hasAttribute('hidden') && !el.classList.contains('bundle-slot--hidden'));
  }

  function getRequiredSlots(root) {
    if (!root) return 0;
    const n = parseInt(root.dataset.requiredSlots || '', 10);
    if (Number.isFinite(n) && n > 0) return n;
    return getActiveSlots(root).length;
  }

  function getSelections() {
    const root = $('[data-bundle-color-pickers]');
    if (!root) return [];

    return getActiveSlots(root).map(slot => {
      const sel = $('[data-bundle-swatch].is-selected', slot);
      return sel ? sel.getAttribute('data-handle') : null;
    });
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || 'Add to cart failed');
    }

    return res.json();
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:change', { detail: { baseEvent: 'variant:add' } }));
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bundle-atc]');
    if (!btn) return;

    e.preventDefault();
    clearError();

    const formId = getFormId();
    const size = getSelectedSize(formId);
    if (!size) {
      showError('Select a size first.');
      return;
    }

    const root = $('[data-bundle-color-pickers]');
    const requiredSlots = getRequiredSlots(root);
    const picks = getSelections(requiredSlots);

    if (!requiredSlots || picks.length !== requiredSlots || picks.some(p => !p)) {
      showError('Select all colors before adding to cart.');
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    const bundleId = (Math.random().toString(36).slice(2) + Date.now().toString(36)).toUpperCase();
    const items = [];

    try {
      for (let i = 0; i < picks.length; i++) {
        const handle = picks[i];
        const stockInfo = getStockInfo(handle, size);

        if (!stockInfo || !stockInfo.available) {
          showError(`One of your selections is sold out in ${size}. Please choose another color.`);
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          return;
        }

        items.push({
          id: stockInfo.variantId,
          quantity: 1,
          properties: {
            _bundle_id: bundleId,
            _bundle_slot: String(i + 1),
            _bundle_size: String(size),
            _bundle_shell: window.location.pathname
          }
        });
      }

      await addItems(items);
      openCart();
    } catch (err) {
      showError(err?.message || 'Add to cart failed.');
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });
})();